'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    AutocompleteMultiSelect: ()=>AutocompleteMultiSelect
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const Autocomplete_cjs_namespaceObject = require("../Autocomplete/Autocomplete.cjs");
const index_cjs_namespaceObject = require("../InputChip/index.cjs");
const external_AutocompleteMultiSelect_variants_cjs_namespaceObject = require("./AutocompleteMultiSelect.variants.cjs");
const AutocompleteMultiSelect = (props)=>{
    const { items, onChange, name, label, selectInputProps, initialSelectedItems, onInputChange, errorMessage } = props;
    const [selectedItems, setSelectedItems] = (0, external_react_namespaceObject.useState)(initialSelectedItems);
    function handleChange(selectedItem) {
        setSelectedItems([
            ...selectedItems,
            selectedItem
        ]);
        if (onChange) onChange(selectedItems);
    }
    function removeSelectedItem(itemValue) {
        setSelectedItems(selectedItems.filter((item)=>item.value !== itemValue));
        if (onChange) onChange(selectedItems);
    }
    function handleInputChange(inputValue) {
        onInputChange(inputValue);
    }
    function onSelectChange() {}
    const { chipSlot } = (0, external_AutocompleteMultiSelect_variants_cjs_namespaceObject.autocompleteMultiSelectVariants)({
        ...props
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        children: [
            selectedItems.length > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                className: chipSlot(),
                children: selectedItems.map((item)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.InputChip, {
                        label: item.itemName,
                        onCloseButtonClick: ()=>removeSelectedItem(item.value),
                        size: "xs"
                    }, item.value))
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Autocomplete_cjs_namespaceObject.Autocomplete, {
                autocompleteData: items.filter((item)=>!selectedItems.some((selectedItem)=>selectedItem.value === item.value)),
                label: label,
                handleSelectItem: handleChange,
                closeMenuOnSelect: false,
                updateInputValueOnSelect: false,
                handleInputChange: handleInputChange,
                errorMessage: errorMessage
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("select", {
                multiple: true,
                "aria-label": name,
                name: name,
                hidden: true,
                ...selectInputProps,
                value: selectedItems.map((item)=>item.value),
                onChange: onSelectChange,
                children: selectedItems.map((item)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("option", {
                        selected: true,
                        value: item.value
                    }, item.value))
            })
        ]
    });
};
exports.AutocompleteMultiSelect = __webpack_exports__.AutocompleteMultiSelect;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "AutocompleteMultiSelect"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
